import i18n from "../i18n";
import {ClimateCommandTypes} from "../constans/mqttMessages";
import moment from "moment/moment";
import {get, isEqual} from "lodash";
import {ValidationDefaultValues} from "../views/new-settings-view/validations/validation-values/ValidationDefaultValues";

export const taskPriorityValueFormatter = (value) => {
    switch (value) {
        case 1:
            return i18n.t("morning");
        case 2:
            return i18n.t("noon");
        case 3:
            return i18n.t("afternoon");
        default:
            return "";
    }
};

export function getDeviceTaskTitle(task) {
    switch (task.Command[0]) {
        case ClimateCommandTypes.SET_CLIMATE_WORK_TYPE: {
            switch (task?.CData?.workType) {
                case "INACTIVE":
                    return `${i18n.t("workType")} - ${i18n.t(
                        "deviceRows.chainFeeding.chainFeedingRow.workTypes.inactive"
                    )}`;
                case "MANUAL":
                    return `${i18n.t("workType")} - ${i18n.t(
                        "deviceRows.chainFeeding.chainFeedingRow.workTypes.manual"
                    )}`;
                case "AUTOMATIC":
                    return `${i18n.t("workType")} - ${i18n.t(
                        "deviceRows.chainFeeding.chainFeedingRow.workTypes.automatic"
                    )}`;
                case "CURVE":
                    return `${i18n.t("workType")} - ${i18n.t(
                        "modals.feedingHistoryModal.curve"
                    )}`;
                default:
                    break;
            }
            return task.Command[0];
        }

        case ClimateCommandTypes.SET_CLIMATE_ALARMS:
            return i18n.t("deviceRows.waterFlowMeter.waterTab.alarms");
        case ClimateCommandTypes.SET_BANDWIDTH:
            return i18n.t("settings.bandwithVenting");
        case ClimateCommandTypes.SET_MAT_MENU:
            return i18n.t("farmView.climate.matSettings");
        case ClimateCommandTypes.SET_CLIMATE_WATER_MATS:
            return i18n.t("settings.waterMatsSettings");
        default:
            return task.Command[0];
    }
}

export function createDateFilter(
    filters,
    obj,
    dateField,
    dateFromField,
    dateToField
) {
    if (!filters[dateField]) return;
    if (filters[dateField].value === "today") {
        obj[dateField] = +moment.utc().startOf("day");
    } else if (filters[dateField].value === "lastWeek") {
        const lastWeek = moment.utc().subtract(1, "week");
        obj[dateFromField] = +lastWeek.clone().startOf("week");
        obj[dateToField] = +lastWeek.clone().endOf("week");
    } else if (filters[dateField].value === "currentWeek") {
        obj[dateFromField] = +moment.utc().startOf("week");
        obj[dateToField] = +moment.utc().endOf("week");
    } else if (filters[dateField].value === "lastMonth") {
        const lastMonth = moment.utc().subtract(1, "month");
        obj[dateFromField] = +lastMonth.clone().startOf("month");
        obj[dateToField] = +lastMonth.clone().endOf("month");
    } else if (filters[dateField].value === "currentMonth") {
        obj[dateFromField] = +moment.utc().startOf("month");
        obj[dateToField] = +moment.utc().endOf("month");
    } else if (filters[dateField].value === "custom") {
        if (filters[dateField].customFrom)
            obj[dateFromField] = +moment.utc(filters[dateField].customFrom);
        if (filters[dateField].customTo)
            obj[dateToField] = +moment
                .utc(filters[dateField].customTo)
                .endOf("day");
    } else if (filters[dateField].value === "last30Days") {
        obj[dateFromField] = +moment.utc().startOf("day").subtract(30, "days");
        obj[dateToField] = +moment.utc().endOf("day");
    } else if (filters[dateField].value === "unassigned") {
        obj[dateField] = 0;
    }
}

export function createFilters(filters) {
    const obj = {};
    if (filters.Title) {
        obj.Title = filters.Title;
    }
    if (filters.IssueID) {
        obj.IssueID = filters.IssueID;
    }
    createDateFilter(
        filters,
        obj,
        "DtaPlanned",
        "DtaPlannedFrom",
        "DtaPlannedTo"
    );
    createDateFilter(
        filters,
        obj,
        "DtaModTime",
        "DtaModTimeFrom",
        "DtaModTimeTo"
    );
    if (filters.AuthorID) {
        obj.AuthorID = filters.AuthorID;
    }
    if (filters.AssignTo) {
        obj.AssignTo = filters.AssignTo;
    }
    if (filters.Category) {
        obj.Category = filters.Category;
    }
    if (filters.Status !== "any") {
        obj.Status = filters.Status;
    }
    if (filters.Observers) {
        obj.Observers = filters.Observers;
    }
    if (filters.Involves) {
        obj.Involves = filters.Involves;
    }
    if (filters.Search) {
        obj.Search = filters.Search;
    }
    console.log(obj);
    return obj;
}

export function shouldGetTasks(currentFilters, date) {
    if (currentFilters.DtaPlanned === date) return true;
    if (currentFilters.DtaPlannedFrom && currentFilters.DtaPlannedTo) {
        if (
            moment
                .utc(date)
                .isBetween(
                    currentFilters.DtaPlannedFrom,
                    currentFilters.DtaPlannedTo,
                    null,
                    "[]"
                )
        )
            return true;
    } else if (currentFilters.DtaPlannedFrom) {
        if (moment.utc(date).isSameOrAfter(currentFilters.DtaPlannedFrom))
            return true;
    } else if (currentFilters.DtaPlannedTo) {
        if (moment.utc(date).isSameOrBefore(currentFilters.DtaPlannedFrom))
            return true;
    }
    return (
        !currentFilters.DtaPlanned &&
        !currentFilters.DtaPlannedFrom &&
        !currentFilters.DtaPlannedTo
    );
}

export function hasAnyFilters(
    filters,
    {hasDate = true, hasProject = true, hasStatus = true} = {}
) {
    const keys = ["AuthorID", "AssignTo", "Category"];
    if (hasProject) {
        keys.push("Project");
    }
    for (let key of keys) {
        if (filters[key]) return true;
    }
    if (hasStatus && filters.Status && filters.Status !== "any") return true;
    if (filters.Title && filters.Title !== "") return true;
    if (!hasDate) return false;
    if (filters.DtaPlanned && filters.DtaPlanned.value !== "any") return true;
    if (filters.IssueID) return true;
    return filters.DtaModTime && filters.DtaModTime.value !== "any";
}

export function shouldShowTaskStatus(task, validations) {
    const isAutomaticTask = !(
        !task?.Type || task?.AutomatedTaskData?.AllowedButtons
    );
    if (isAutomaticTask) {
        const markTaskAsCompleted = get(
            validations,
            "markTaskAsCompleted",
            ValidationDefaultValues.markTaskAsCompleted
        );
        const markTaskAsCompletedAfterDate = get(
            validations,
            "markTaskAsCompletedAfterDate",
            ValidationDefaultValues.markTaskAsCompletedAfterDate
        );
        return !(
            markTaskAsCompleted ||
            (markTaskAsCompletedAfterDate &&
                !moment
                    .utc()
                    .isBetween(
                        task?.DtaPlanned,
                        task?.DtaPlannedEnd || moment.utc().endOf("day"),
                        "day"
                    ))
        );
    }
    return true;
}
export function modifyObjectWithGroupBy(
    obj,
    sortType,
    groupBy,
    filter,
    isMultiProjectView = false,
    reverseDates = true
) {
    const isToday = filter?.DtaPlanned?.value === "today";
    const timeTypes = ["DtaPlanned", "DtaModTime"];
    obj.Reversed = reverseDates;
    // obj.Reversed = timeTypes.includes(groupBy)
    //     ? !isToday
    //     : false;
    const newDay = +moment.utc().add(1, "day").endOf("day");
    if (sortType === "ASC") {
        if (groupBy === "DtaModTime") {
            if (reverseDates) {
                obj.DtaModTimeTo = newDay;
            } else {
                obj.DtaModTimeFrom = newDay;
            }
        } else {
            if (!isToday)
                if (reverseDates) {
                    obj.DtaPlannedTo = newDay;
                } else {
                    obj.DtaPlannedFrom = newDay;
                }
        }
    } else {
        //DESC
        if (!timeTypes.includes(groupBy)) {
            if (filter.Filters?.DtaPlanned?.value !== "today") {
                if (reverseDates) {
                    obj.DtaPlannedTo = newDay;
                } else {
                    obj.DtaPlannedFrom = newDay;
                }
            }
        } else {
            if (groupBy === "DtaModTime") {
                if (reverseDates) {
                    obj.DtaModTimeTo = newDay;
                } else {
                    obj.DtaModTimeTo = newDay;
                }
            }
        }
    }
}
export const isWesstronClient = (ClientID) => {
    return ClientID === "PL-WESSTRON-CbqKQtNoPaHSlIMNIfQF";
};
export const getDefaultBookmarks = (LocalUserID, ClientID) => {
    const isWesstron = isWesstronClient(ClientID);
    const defaultBookmarks = {
        1: {
            PrefData: {
                Name: i18n.t("taskTodayMine"),
                icon: "fa-solid fa-calendar-circle-user",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "today",
                    },
                    AssignTo: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaPlanned",
                    sort: "ASC",
                },
            },
        },
        2: {
            PrefData: {
                Name: i18n.t("taskToday"),
                icon: "fa-solid fa-calendar-day",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "today",
                    },
                },
                Aggregation: {
                    groupBy: "DtaPlanned",
                    sort: "ASC",
                },
            },
        },
        3: {
            PrefData: {
                Name: i18n.t("all"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "any",
                    },
                },
                Aggregation: {
                    groupBy: "DtaPlanned",
                    sort: "ASC",
                },
            },
        },

        5: {
            PrefData: {
                Name: i18n.t("lastModificationShort"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "any",
                    },
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        6: {
            PrefData: {
                Name: i18n.t("filters.my"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "OPENED",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        7: {
            PrefData: {
                Name: i18n.t("filters.observed"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "any",
                    },
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        8: {
            PrefData: {
                Name: i18n.t("filters.created"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "any",
                    },
                    AuthorID: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        9: {
            PrefData: {
                Name: i18n.t("filters.forMe"),
                icon: "fa-solid fa-list-check",
                Filters: {
                    Status: "any",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        10: {
            PrefData: {
                Name: i18n.t("filters.closed"),
                icon: "fa-solid fa-calendar-check",
                Filters: {
                    Status: "DONE",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                    AuthorID: [LocalUserID],
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
    };

    const wesstronBookmarks = {
        1: {
            PrefData: {
                Name: "Moje",
                icon: "fa-solid fa-user",
                Filters: {
                    Status: "OPENED",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaPlanned",
                    sort: "ASC",
                },
            },
        },
        2: {
            PrefData: {
                Name: "Zgłoszone",
                icon: "fa-solid fa-paper-plane",
                Filters: {
                    Status: "OPENED",
                    DtaPlanned: {
                        value: "any",
                    },
                    AuthorID: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaPlanned",
                    sort: "ASC",
                },
            },
        },
        3: {
            PrefData: {
                Name: "Ostatnie",
                icon: "fa-solid fa-clock-rotate-left",
                Filters: {
                    Status: "OPENED",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        4: {
            PrefData: {
                Name: i18n.t("filters.closed"),
                icon: "fa-solid fa-calendar-check",
                Filters: {
                    Status: "DONE",
                    DtaPlanned: {
                        value: "any",
                    },
                    AssignTo: [LocalUserID],
                    AuthorID: [LocalUserID],
                    Observers: [LocalUserID],
                },
                Aggregation: {
                    groupBy: "DtaModTime",
                    sort: "ASC",
                },
            },
        },
        5: defaultBookmarks[1],
        6: defaultBookmarks[2],
        7: defaultBookmarks[3],
        // 8: defaultBookmarks[5],
        // 9: defaultBookmarks[6],
        8: defaultBookmarks[7],
        // 11: defaultBookmarks[8],
        9: defaultBookmarks[9],
    };

    return isWesstron ? wesstronBookmarks : defaultBookmarks;
};

export function filterTasksByDate(tasks, startDate, endDate) {
    const result = {};

    for (const key in tasks) {
        const keyTime = new Date(key).getTime();
        if (keyTime >= startDate && keyTime <= endDate) {
            result[key] = tasks[key];
        }
    }
    return result;
}

export const modifyDateFilters = (object, filters, fetchMonth, groupBy) => {
    const isToday = filters?.DtaPlanned?.value === "today";
    if (
        filters?.DtaPlanned ||
        filters?.DtaPlannedFrom ||
        filters?.DtaPlannedTo
    ) {
        return;
    }
    if (groupBy === "DtaPlanned") {
        if (isToday) {
            object.DtaPlanned = +moment.utc().startOf("day");
        } else {
            object.DtaPlannedFrom = fetchMonth;
            object.DtaPlannedTo = +moment
                .utc(fetchMonth)
                .add(1, "months")
                .endOf("month");
        }
    } else if (groupBy === "DtaModTime") {
        object.DtaModTimeFrom = fetchMonth;
        object.DtaModTimeTo = +moment
            .utc(fetchMonth)
            .add(1, "months")
            .endOf("month");
    }
};

export function getFetchTaskMonth(
    position = "top",
    changeMonth = true,
    fetchMonthStart,
    fetchMonthEnd
) {
    if (position === "top") {
        if (changeMonth) {
            return +moment
                .utc(fetchMonthStart)
                .subtract(1, "month")
                .startOf("month");
        }
        return fetchMonthStart;
    } else {
        if (changeMonth) {
            return +moment.utc(fetchMonthEnd).add(1, "month").endOf("month");
        }
        return fetchMonthEnd;
    }
}

export function createGroups(project, status, ProjID) {
    const filters =
        project || status === "all" || status === "devices"
            ? {}
            : {Status: status};
    const groups = [
        {
            name: status,
            filters,
            selector: status === "devices" ? "devices" : undefined,
        },
    ];
    if (status !== "devices") {
        groups[0]["FarmID"] = project ? status : ProjID;
    }
    return groups;
}

export function getProjectIdsFromGroups(groups) {
    return groups.map((group) => group.ProjID);
}

/**
 * Tworzy obiekt History na podstawie porównania starego i nowego stanu zadania
 * @param {Object} oldTask - Stary stan zadania
 * @param {Object} newTaskData - Nowe dane zadania (z body requestu)
 * @param {string} LocalUserID - ID użytkownika dokonującego zmiany
 * @returns {Object|null} - Obiekt History lub null jeśli brak zmian
 */
export function createTaskHistory(oldTask, newTaskData, LocalUserID) {
    const fields = [];

    // Lista monitorowanych pól z ich nazwami
    const monitoredFields = [
        "AssignTo",
        "DtaPlanned",
        "Private",
        "Category",
        "Priority",
        "Status",
        "Title",
        "Description",
        "EstimatedTime",
        "Observers",
        "DtaPlannedEnd",
        "FarmID",
        "ListTODO",
    ];

    // Sprawdzanie każdego pola
    for (const fieldName of monitoredFields) {
        const newValue = newTaskData[fieldName];
        const oldValue = oldTask[fieldName];

        // Pomijamy undefined (pole nie zostało przesłane w requestcie)
        if (newValue === undefined) continue;

        // Specjalny case dla null (usunięcie pola)
        if (newValue === null && oldValue !== null && oldValue !== undefined) {
            fields.push({
                Name: fieldName,
                OldValue: oldValue,
                NewValue: null,
            });
            continue;
        }

        // Porównanie wartości
        if (!isEqual(oldValue, newValue)) {
            fields.push({
                Name: fieldName,
                OldValue: oldValue,
                NewValue: newValue,
            });
        }
    }

    // Jeśli nie ma zmian, zwróć null
    if (fields.length === 0) return null;

    // Zwróć obiekt History
    return {
        Time: +new Date(),
        LocalUserID,
        Fields: fields,
    };
}
